export function debounce(func, wait, immediate) {
  let timeout;
  return function debouncedFunction() {
    const context = this;
    const args = arguments; // eslint-disable-line
    const later = function later() {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    const callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
}

export default {
  debounce,
};



// WEBPACK FOOTER //
// ./src/utils/debounceUtils.js